import { useEffect } from 'react';
import { useParams } from 'react-router';
import PersonaRecibeForm from '../../components/personal-recibe/PersonaRecibeForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalRecibeStore,
  type ActualizarPersonaRecibe
} from '../../stores/personal-recibe/personal-recibe.store';

const EditarPersonaRecibe = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: persona,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = usePersonalRecibeStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
    cargarCiudades();
    cargarEstados();
  }, [id]);

  const handleSave = (values: ActualizarPersonaRecibe) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <PersonaRecibeForm
      persona={persona}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default EditarPersonaRecibe;
